import { useContext } from "react";
import { HttpMethods } from "../../enums/HttpMethods";
import { NotificationTypes } from "../../enums/NotificationTypes";
import VspPortalContext from "../../store/VspPortalContext";
import { IotGatewayEventDto } from "./dtos/IotGatewayEventDto";
import { IotGatewayEventLatestDto } from "./dtos/IotGatewayEventLatestDto";
import { IotGatewayEventSummaryDto } from "./dtos/IotGatewayEventSummaryDto";
import { VspPortalActions } from "../../store/VspPortalActions";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";



export const useIotGatewayEvents = (): {

    getIotGatewayEvents( networkMacAddress: string, villageCode: string ): Promise<IotGatewayEventDto[] | null>
    , getIotGatewayEventsLatest( villageCode: string, statuses: string[ ] ): Promise<IotGatewayEventLatestDto[] | null>
    , getIotGatewayEventsSummary( villageCode: string ): Promise<IotGatewayEventSummaryDto[] | null>

} => {

    const { fetchData, getHttpOptions } = useVspPortalHttp( );
    const { dispatch, state } = useContext( VspPortalContext );


    const getIotGatewayEvents = async( networkMacAddress: string, villageCode: string ): Promise<IotGatewayEventDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/iotgateway/event?villageCode=${villageCode}&networkMacAddress=${networkMacAddress}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching IoT Gateway events' });
            return null;

        }

        return await response.response?.json( );

    };

    
    const getIotGatewayEventsLatest = async( villageCode: string, statuses: string[ ] ): Promise<IotGatewayEventLatestDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/iotgateway/event/Latest?villageCode=${villageCode}&statuses=` + statuses.join( '&statuses=' );
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching latest IoT Gateway statuses' });

            return null;

        }

        return await response.response?.json( );        
        
    };
    

    const getIotGatewayEventsSummary = async( villageCode: string ): Promise<IotGatewayEventSummaryDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/iotgateway/event/summary?villageCode=${villageCode}`;
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching IoT Gateway events summary' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            return await response.response?.json( );

        }

        return [ ];
        
    };


    return {

        getIotGatewayEvents
        , getIotGatewayEventsLatest
        , getIotGatewayEventsSummary

    };

};
